export enum DataHooks {
  ROOT = 'discount-name-root',
  TOOLTIP = 'discount-name-tooltip',
}
